export default __webpack_public_path__ + "media/26d064abd0fecc2841dbf090c550baa77afca53058e8343fe9639efe59bd6262.svg";